import React, {useState} from "react";

export const TabsContext = React.createContext('');

let keepTab = false;

export const TabsProvider = ({value, children}) => {

    const [keyTabsMap, setKeyTabsMap] = useState([]);

    function updateTabKey(pagina, valore) {
        if (valore || !keepTab) {
            setKeyTabsMap(prevState => ({
                ...prevState,
                [pagina]: valore
            }));

            if (valore !== null) {
                keepTab = true;
            }
        }
    }

    function getTabKey(pagina) {
        return keyTabsMap[pagina] || '';
    }

    function setKeepTab(pagina, k) {
        keepTab = k;
    }

    return (
        <TabsContext.Provider
            value={{
                updateTabKey,
                getTabKey,
                setKeepTab,
            }}>{children}</TabsContext.Provider>
    );
};
